import React, { Dispatch, SetStateAction } from "react"

import { NotificationManager } from "react-notifications"
import { gql, useMutation } from "urql"

import { Color } from "~tailwindui/types/enums"

import { Button } from "~tailwindui/Basics"
import Modal from "~tailwindui/Modal"

import { SubjectBucket } from "./Table"

type RemoveSubjectBucketButtonProps = {
  subjectBucket?: SubjectBucket
  setSubjectBucket: Dispatch<SetStateAction<SubjectBucket>>
  refetchQuery: VoidFunction
}

const RemoveSubjectBucketButton: React.FC<RemoveSubjectBucketButtonProps> = ({
  subjectBucket,
  setSubjectBucket,
  refetchQuery,
}) => {
  const [, runRemoveMutation] = useMutation(removeTutorSubject)

  if (!subjectBucket) return null

  const handleRemove = () => {
    runRemoveMutation({ subjectBucketId: subjectBucket.id })
      .then(
        response => {
          const { failures } = response.data.removeTutorSubject
          if (failures.length > 0)
            NotificationManager.error(failures[0].message)
          else {
            refetchQuery()
            setSubjectBucket(null)
            NotificationManager.success("Subject removed")
          }
        },
        () => NotificationManager.error("Something went wrong")
      )
      .catch(() => NotificationManager.error("Something went wrong"))
  }

  const closeModal = () => setSubjectBucket(null)

  return (
    <>
      <Modal.Dialog hideButton isOpen closeModal={closeModal}>
        <>
          <Modal.Header hideCloseButton>
            Remove {subjectBucket.name}
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to remove "{subjectBucket.name}"? You will no
            longer be eligible to tutor sessions in this subject.
          </Modal.Body>
          <Modal.Footer>
            <div className="flex justify-between">
              <Button onClick={closeModal}>No, Keep</Button>
              <Button type="submit" color={Color.Red} onClick={handleRemove}>
                Yes, Remove
              </Button>
            </div>
          </Modal.Footer>
        </>
      </Modal.Dialog>
    </>
  )
}

const removeTutorSubject = gql`
  mutation RemoveTutorSubject($subjectBucketId: ID!) {
    removeTutorSubject(subjectBucketId: $subjectBucketId) {
      failures {
        message
      }
    }
  }
`

export default RemoveSubjectBucketButton
